import { Link as RouterLink } from 'react-router-dom';

// Single source of truth for the primary navigation, mirroring the original
// qasc.it menu: Chi siamo · Formazione (▾) · Consulenza (▾) · Corsi in
// evidenza · Contatti · News. Items with `children` render as dropdowns on
// desktop and collapsible groups in the mobile drawer.
export const NAV_ITEMS = [
  { label: 'Chi siamo', to: '/chi-siamo' },
  {
    label: 'Formazione',
    to: '/formazione',
    children: [
      { label: 'Formazione Sicurezza', to: '/formazione/formazione-sicurezza' },
      { label: 'E-Learning', to: '/e-learning' },
      { label: 'Ambiente e Qualità', to: '/formazione/ambiente-e-qualita' },
      { label: 'Finanziata', to: '/formazione-finanziata' },
    ],
  },
  {
    label: 'Consulenza',
    to: '/consulenza',
    children: [
      { label: 'Sistemi di gestione', to: '/consulenza#auditing' },
      { label: 'Valutazione del rischio', to: '/consulenza#rischio' },
      { label: 'Modello organizzativo 231', to: '/consulenza#modello' },
      { label: 'Sicurezza alimentare', to: '/consulenza#alimentare' },
    ],
  },
  { label: 'Corsi in evidenza', to: '/corsi-in-evidenza' },
  { label: 'Contatti', to: '/contatti' },
  { label: 'News', to: '/news' },
];

// Props to spread onto a MUI Button / ListItem.
export function navLinkProps(item) {
  if (item.hash) return { component: 'a', href: item.hash };
  return { component: RouterLink, to: item.to };
}

// Whether a nav item is the active route for the current pathname.
export function isNavActive(item, pathname) {
  if (!item.to) return false;
  const base = item.to.split('#')[0];
  if (!base) return false;
  if (base === '/') return pathname === '/';
  if (pathname === base || pathname.startsWith(`${base}/`)) return true;
  // A parent is active when any child route is.
  return (item.children || []).some((c) => isNavActive(c, pathname));
}
